import React, { useMemo, useState } from "react";
import { withFirebase } from "../Firebase";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DevLoginBase = ({ firebase }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isDevEnv = useMemo(() => {
    return (
      window.location.hostname === "localhost" &&
      String(process.env.REACT_APP_DEV_LOGIN || "").toLowerCase() === "true"
    );
  }, []);

  const baseUrl = i18n.language === "sv" ? "" : "/" + i18n.language;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!isDevEnv) {
      setError("Dev login is disabled.");
      return;
    }

    if (!email) {
      setError("Email is required.");
      return;
    }

    const secret = process.env.REACT_APP_DEV_LOGIN_SECRET || "";
    if (!secret) {
      setError("Missing dev secret in environment.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        process.env.REACT_APP_FIREBASE_FUNCTION_URL + "getLoginWithToken",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-DEV-AUTH": secret,
          },
          body: JSON.stringify({ email }),
        }
      );

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || "Dev login failed");
      }

      const data = await res.json();
      if (!data.customToken) {
        throw new Error("No custom token returned");
      }

      await firebase.signInWithCustomToken(data.customToken);
      navigate(baseUrl + "/payment");
    } catch (err) {
      setError(err.message || String(err));
    } finally {
      setLoading(false);
    }
  };

  if (!isDevEnv) {
    return (
      <div className="container" style={{ maxWidth: 520, margin: "40px auto" }}>
        <h2>Dev Login</h2>
        <p>Dev login is disabled. Enable it only on localhost.</p>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: 520, margin: "40px auto" }}>
      <h2>Dev Login</h2>
      <p style={{ opacity: 0.8 }}>
        This tool signs in as a user via a Firebase custom token. Use only on
        localhost.
      </p>
      <form onSubmit={handleSubmit}>
        <label style={{ display: "block", marginBottom: 8 }}>User email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="user@example.com"
          style={{ width: "100%", padding: 10, marginBottom: 12 }}
        />
        {error ? (
          <div style={{ color: "#b00020", marginBottom: 12 }}>{error}</div>
        ) : null}
        <button type="submit" disabled={loading}>
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
};

const DevLoginPage = withFirebase(DevLoginBase);
export default DevLoginPage;
